import { Stack } from '@mui/material';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { DialogPromptEnterName } from '../../api/DialogPromptApi';
import { IUser, UserApi } from '../../api/UserApi';
import AppBarContext from '../../context/AppBarContext';
import DialogPromptFooterContext from '../../context/DialogPromptFooterContext';
import ChatBubble from '../ChatBubble';
import { handleErrorMessage } from '../ErrorDialog';
import SendButtonTextField from '../SendButtonTextField';
import { getAudioByText } from './DialogPromptComponent';

interface DialogPromptEnterNameComponentProps {
    dialogPrompt: DialogPromptEnterName;
    setDialogPromptComplete: (dialogPromptId: number) => void;
    showAvatar?: boolean;
    chatBubbleContainerRef: React.RefObject<HTMLDivElement>;
    isSettings?: boolean;
}

const DialogPromptEnterNameComponent: React.FC<DialogPromptEnterNameComponentProps> = ({ dialogPrompt, setDialogPromptComplete, showAvatar = true, chatBubbleContainerRef, isSettings = false }) => {

    const { setErrorMessage } = React.useContext(AppBarContext)
    const history = useHistory();
    const location = useLocation();

    const { setActionList, clearFooterList } = React.useContext(DialogPromptFooterContext)

    const [studentName, setStudentName] = React.useState<string | null>('');
    const [chatBubbleDone, setChatBubbleDone] = React.useState(false);

    const [promptAudio, setPromptAudio] = React.useState<Blob | null | undefined>(undefined);


    React.useEffect(() => {
        clearFooterList()
        getAudioByText(history, setErrorMessage, dialogPrompt.prompt, setPromptAudio, isSettings)
        setStudentName(localStorage.getItem('studentName'));
    }, [clearFooterList, dialogPrompt.prompt, history, isSettings, setErrorMessage]);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const studentName = event.target.value;
        setStudentName(studentName);
    };

    const handleNameChange = React.useCallback(() => {
        if (studentName) {
            localStorage.setItem('studentName', studentName);
            const updatedUser: IUser = {
                first_name: studentName,
            };
            // Call the update function
            UserApi.update(updatedUser)
                .then(() => {
                    // Handle the response
                    // console.log('User updated:', response.data);
                })
                .catch(err => {
                    handleErrorMessage(err, setErrorMessage, history, location);
                });
        }
    }, [studentName, setErrorMessage, history, location]);

    const handleButtonClick = React.useCallback(() => {
        if (studentName) {
            // save name
            handleNameChange();
            // Perform any desired action with the student name
            setDialogPromptComplete(dialogPrompt.id);
        }
    }, [studentName, handleNameChange, setDialogPromptComplete, dialogPrompt.id]);

    const handleKeyDown = React.useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            handleButtonClick();
        }
    }, [handleButtonClick]);

    React.useEffect(() => {
        if (chatBubbleDone) {
            setActionList([
                <SendButtonTextField
                    value={studentName || ''}
                    onChange={handleInputChange}
                    onSubmit={handleButtonClick}
                    onKeyDown={handleKeyDown}
                    sx={{ width: '100%', flexGrow: 1 }} // Directly control the width here
                    autoFocus
                />
            ])
        }
    }, [studentName, chatBubbleDone, handleButtonClick, handleKeyDown, setActionList]);

    return (
        <Stack>
            <ChatBubble
                isTeacher={dialogPrompt.is_teacher}
                message={dialogPrompt.prompt}
                messageAudio={promptAudio ? promptAudio : null}
                showAvatar={showAvatar}
                setChatBubbleDone={setChatBubbleDone}
                chatBubbleContainerRef={chatBubbleContainerRef}
            />
        </Stack>
    );
};

export default DialogPromptEnterNameComponent;

